import React, { useState, useEffect } from "react";
import { txtA } from "../../../../Label/Lbl";
import axios from "axios";
import { uri } from "../../../../help/Api";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import ButtonBase from "@material-ui/core/ButtonBase";
import {
  useInvAF,
  useInvCa,
  useInvMain,
} from "../../../../St/Reviews/UseStyle";
import { sto } from "../../../../Context/InshData";

function HeaderSand(props) {
  const clasm = useInvMain();
  const clas = useInvCa();
  const {info, onUnmountComplete } = props;

  const style2= {
    textAlign: "center",
    paddingTop: "0.01rem",
    paddingBottom: "0.01rem",
    fontSize: "0.95rem",
    color: "black",
    fontWeight: "bold",
  };

  const styleLeft= {
    textAlign: "left",
    paddingTop: "0.01rem",
    paddingBottom: "0.01rem",
    fontSize: "0.95rem",
    color: "black",
    fontWeight: "bold",
  };


  // useEffect(() => {
  //   setTimeout(async () => {
  //     onUnmountComplete();
  //   }, 0);
  // }, []);
  return (
    <Grid item container className={[clasm.HedrootSKh, clas.Hedroot]}>
      <Grid item xs={12} className={clasm.mincntr}>
        <Typography>
          <ButtonBase>
            {" "}
            <img
              src={`data:image/jpeg;base64,${info.Logo}`}
              className={clas.Hedlogo}
              alt={info.nameA}
            />{" "}
          </ButtonBase>
        </Typography>
      </Grid>


      <Grid item xs={12}>
        <Typography className={clasm.mincntr} style={style2}>{info.nameA}</Typography>
      </Grid>
      <Grid item xs={12}>
        <Typography className={clasm.mincntr} style={style2}>{info.nameE}</Typography>
      </Grid>
      <Grid item xs={4}>
        <Typography className={clasm.mincntr} style={style2}>{info.Mobile}</Typography>
      </Grid>
      <Grid item xs={8}>
        <Typography className={clasm.mincntr} style={style2}>{info.Address}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={styleLeft}>{info.tax_no}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={style2}>{"الرقم الضريبي"} </Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={styleLeft}>{info.bsn_no}</Typography>
      </Grid>
      <Grid item xs={6}>
        <Typography className={clasm.mincntr} style={style2}>{"السجل التجاري "} </Typography>
      </Grid>

    </Grid>
  );
}
export default HeaderSand;
